import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SelectModule } from 'src/app/common/select/select.module';
import { FormBuilder, FormsModule } from '@angular/forms';
import { ButtonModule } from 'src/app/common/button/button.module';
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service';
import { EventsService, FundraiserService, UtilService, VariablesService } from 'src/app/shared/services';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { PRICE_BREAKUP_INFO } from './price-breakup-info';
import { MatButtonModule } from '@angular/material/button';
import { CloseBtnModule } from 'src/app/common/close-btn/close-btn.module';
import { HealthFirstService } from '../../services/health-first.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HEALTHFIRST_HOME_INFO } from '../hf-home/home-info';
import { environment } from 'src/environments/environment';
import { PaymentUtilService } from 'src/app/common/payment/services';

@Component({
  selector: 'app-hf-price-breakup',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatSlideToggleModule,
    SelectModule,
    FormsModule,
    ButtonModule,
    MatBottomSheetModule,
    MatButtonModule,
    CloseBtnModule
  ],
  providers: [PaymentUtilService],
  templateUrl: './hf-price-breakup.component.html',
  styleUrls: ['./hf-price-breakup.component.scss']
})
export class HfPriceBreakupComponent {

  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    public util: UtilService,
    private bottomSheet: MatBottomSheet,
    private hfService: HealthFirstService,
    private vars: VariablesService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private eventService: EventsService,
    private fundraiserService: FundraiserService,
    private paymentUtilService: PaymentUtilService
  ) {
    this.subs.push(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && this.util.isMobile()) {
        this.getParams();
      }
    }))
  }
  subs = [];
  policyDatas;
  qparamPlans;
  selectedPlan;
  info = HEALTHFIRST_HOME_INFO;
  totalPayableAmount = 1509;
  priceBreakupInfo = PRICE_BREAKUP_INFO;
  @ViewChild('dialogRef') dialogRef;
  breakupGroup;
  criticalMapper;
  priceBreakups = [
    { id: 1, title: 'Plan Price', price: '3400' },
    { id: 2, title: 'Discount', price: '1901' },
  ]

  peopleOptions = [];
  planOptions = [];
  selectedPlanFromDropdown;
  selectedPeople;
  userPhone;
  bottomsheetRef;
  dialogObjectRef;

  currency = 'INR';
  isLoading = false;

  ngOnInit() {
    this.initForm();
    this.getParams();
    this.checkHfData();
    this.getUserData();
    this.vars.pageName = 'chooseplan';
    if (this.util.isMobile()) {
      this.getHFCampaign();
    }
  }

  getHFCampaign() {
    this.paymentUtilService.paymentCurrency.next(this.currency);
    const qParams = `?with=beneficiary;campaigner;storyTitle;tipModel&currency=${this.currency}&showError=false`;
    this.fundraiserService.getCampaign(environment.health_first_ct, qParams).subscribe(async (res: any) => {
      this.vars.fundraiser = res.data;
      const selected = this.util.setSelectedInsurance({
        vendor: 'medibuddy',
        plan: this.qparamPlans,
        frequency: 'yearly',
        currency: this.currency
      });
    });
  }

  getUserData() {
    if (typeof window !== 'undefined') {
      const user: any = JSON.parse(localStorage.getItem('userdata'));
      this.userPhone = '<strong> +91 ' + user.phone_1 + '</strong>';
    }
  }

  pageViewEvent() {
    const payload = {
      eventName: 'cart_pageview',
      page_name: 'chooseplan',
      info_1: this.qparamPlans,
      info_2: this.selectedPlan.yearly.amount,
      info_3: 'hero_cta'
    }
    payload['info_3'] = this.hfService.selectedBenefit ? this.hfService.selectedBenefit.info_2 : 'hero_cta'
    this.sendEvent(payload);
    this.eventService.claverTapPush('Healthfirst PageView', {
      'Event Name': 'cart_pageview',
      'info_1': this.qparamPlans,
      'info_2': this.selectedPlan.yearly.amount,
      'info_3': 'hero_cta'
    });
  }

  ngAfterViewInit() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        this.util.scrollToTop();
      }, 500);
    }
  }

  getParams() {
    const plan = this.actRoute.snapshot.queryParams['plan'];
    if (plan && ['essentials', 'plus'].includes(plan)) {
      this.qparamPlans = plan;
    } else {
      this.qparamPlans = 'essentials';
    }
  }

  checkHfData() {
    if (this.vars.hfDashboardData && Object.keys(this.vars.hfDashboardData).length > 0) {
      this.setInfoData(this.vars.hfDashboardData);
      this.pageViewEvent();
    } else {
      this.getHealthPlans();
    }
  }

  setInfoData(data) {
    this.info.plansMob = [];
    const { critical_illness, policies } = data.data.healthfirst;
    this.policyDatas = { ...policies.plans };
    this.criticalMapper = critical_illness;
    this.selectedPlan = this.policyDatas[this.qparamPlans];
    this.priceBreakups.map(item => {
      if (item.id === 1) {
        item.price = this.selectedPlan.yearly.plan_price;
      }
      if (item.id === 2) {
        item.price = this.selectedPlan.yearly.discount;
      }
    });
    this.calculateTotalPayable();
    this.peopleOptions = critical_illness.person.map((item, index) => {
      return {
        id: index + 1,
        label: item,
        value: item
      }
    });
    this.planOptions = critical_illness.cover_amount.map((item, index) => {
      return {
        id: index + 1,
        label: item,
        value: item
      }
    });
  }

  getHealthPlans() {
    this.hfService.getHealthFirstData().subscribe(data => {
      if (data) {
        this.vars.hfDashboardData = data;
        this.setInfoData(data);
        this.pageViewEvent();
      }
    })
  }

  initForm() {
    this.breakupGroup = this.fb.group({
      critical: [false,],
      people: ['1 person',],
      plan: ['1 lakh',]
    });

    this.selectedPeople = this.breakupGroup.get('people').value;
    this.selectedPlanFromDropdown = this.breakupGroup.get('plan').value;
  }

  onPeopleChange(event) {
    this.selectedPeople = event;
    this.onToggleChange({ checked: true }, true);
  }

  onPlanChange(event) {
    this.selectedPlanFromDropdown = event;
    this.onToggleChange({ checked: true }, true);
  }

  onToggleChange(event, sendEvent = true) {
    if (event.checked) {
      const criticalPrice = this.criticalMapper[this.selectedPeople][this.selectedPlanFromDropdown];
      if (this.priceBreakups.some(item => item.id === 3)) {
        this.priceBreakups = this.priceBreakups.filter(item => item.id !== 3);
      }
      this.priceBreakups.push({
        id: 3,
        title: 'Critical Illness Add on',
        price: criticalPrice
      });
      this.calculateTotalPayable();
      const payload = {
        eventName: 'switchon',
        info_1: this.qparamPlans,
        info_2: this.selectedPlan?.yearly?.amount,
      }
      payload['info_3'] = this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService.selectedBenefit.info_2) : 'hero_cta'
      if (sendEvent) {
        this.sendEvent(payload);
        this.eventService.claverTapPush('Healthfirst Critical illness Toggle button', {
          'Event Name': 'switchon',
          'info_1': this.qparamPlans,
          'info_2': this.selectedPlan?.yearly?.amount,
          'info_3': this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService?.selectedBenefit?.info_2) : 'hero_cta'
        });
      }
    } else {
      this.priceBreakups = this.priceBreakups.filter(item => item.id !== 3);
      this.calculateTotalPayable();
      const payload = {
        eventName: 'switchoff',
        info_1: this.qparamPlans,
        info_2: this.selectedPlan?.yearly?.amount,
      }
      payload['info_3'] = this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService?.selectedBenefit?.info_2) : 'hero_cta'
      if (sendEvent) {
        this.sendEvent(payload);
        this.eventService.claverTapPush('Healthfirst Critical illness Toggle button', {
          'Event Name': 'switchoff',
          'info_1': this.qparamPlans,
          'info_2': this.selectedPlan?.yearly?.amount,
          'info_3': this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService?.selectedBenefit?.info_2) : 'hero_cta'
        })
      }
    }
  }

  calculateTotalPayable() {
    this.totalPayableAmount = this.priceBreakups.reduce((acc, current) => {
      if (current.title === 'Discount') {
        return acc - parseInt(current.price);
      } else {
        return acc + parseInt(current.price);
      }
    }, 0);
  }


  openDialogOrBottomSheet() {
    if (this.util.isMobile()) {
      this.bottomsheetRef = this.bottomSheet.open(this.dialogRef, {
        panelClass: 'hf-critical-illness-info'
      });
    } else {
      this.dialogObjectRef = this.dialogService.openDialogViaTemplate(this.dialogRef, {
        width: '512px',
        height: '570px',
        panelClass: 'hf-critical-illness-info',
        closeOnNavigation: true
      });
    }
  }

  onCriticalSelected() {
    this.onToggleChange({ checked: true }, false);
    this.breakupGroup.get('critical').patchValue(true);
    this.dialogService.closeAll();
    this.sendEvent({
      eventName: 'yes',
      page_name: 'criticalillness'
    });
    this.vars.pageName = 'criticalillness';
    this.eventService.claverTapPush('Healthfirst Critical Illness Pop-Up', {
      'Event Name': 'yes'
    });
    if (this.util.isMobile()) {
      this.bottomsheetRef.dismiss();
    } else {
      this.dialogObjectRef.close();
    }
  }

  onCriticalRejected() {
    this.onToggleChange({ checked: false }, false);
    this.breakupGroup.get('critical').patchValue(false);
    this.dialogService.closeAll();
    const payload = {
      eventName: 'no',
      page_name: 'criticalillness'
    }
    payload['info_3'] = this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService.selectedBenefit.info_2) : ''
    this.sendEvent(payload);
    this.vars.pageName = 'criticalillness';
    this.eventService.claverTapPush('Healthfirst Critical Illness Pop-Up', {
      'Event Name': 'no',
    });
    if (this.util.isMobile()) {
      this.bottomsheetRef.dismiss();
    } else {
      this.dialogObjectRef.close();
    }
  }

  async onPayClick() {
    const personVal = {
      '1 person': 1,
      '2 person': 2,
      '3 person': 3,
      '4 person': 4,
    }
    const planVal = {
      '1 lakh': 1,
      '2 lakh': 2,
      '3 lakh': 3,
      '4 lakh': 4,
      '5 lakh': 5,
    }
    const qparams = {
      ct: environment.health_first_ct,
      id: environment.health_first_campaign_id,
      plan: this.qparamPlans,
      vendor: 'medibuddy',
      ref: 'healthfirst'
    }
    if (this.breakupGroup.get('critical').value) {
      qparams['person'] = personVal[this.selectedPeople];
      qparams['cover'] = planVal[this.selectedPlanFromDropdown]
    }
    const payload = {
      eventName: 'paynow',
      page_name: 'chooseplan',
      info_1: `${this.qparamPlans}, ${this.selectedPlan.yearly.amount}`,
      info_2: this.breakupGroup.get('critical').value ? `${personVal[this.selectedPeople]}, ${planVal[this.selectedPlanFromDropdown]}` : '',
    }

    payload['info_3'] = this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService?.selectedBenefit?.info_2) : 'hero_cta'
    this.sendEvent(payload);
    this.eventService.claverTapPush('Healthfirst chooseplan', {
      'Event Name': 'paynow',
      'info_1': `${this.qparamPlans}, ${this.selectedPlan.yearly.amount}`,
      'info_2': this.breakupGroup.get('critical').value ? `${personVal[this.selectedPeople]}, ${planVal[this.selectedPlanFromDropdown]}` : '',
    })
    if (this.util.isMobile()) {
      await this.createCart();
    }
    this.router.navigate(['/new/payment'], {
      queryParams: qparams,
    });
  }

  createCart() {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      if (this.breakupGroup.get('critical').value) {
        const criticalPrice = this.criticalMapper[this.selectedPeople][this.selectedPlanFromDropdown];
        this.vars.event_info.info_1 = this.selectedPeople?.split(' ')?.[0] + '; ' + criticalPrice;
      } else {
        this.vars.event_info.info_1 = '';
      }
      this.vars.event_info.info_3 = this.vars.selected_insurance.plan_text + ' Plan; ' + this.selectedPlan?.yearly?.amount;
      this.paymentUtilService.createCart(this.totalPayableAmount, false).then(() => {
        this.isLoading = false;
        resolve(true);
      }).catch(() => {
        this.isLoading = false;
        resolve(true);
      });
    });
  }

  sendEvent(payload) {
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }
}
